import {Flex, Text, Button} from '@priority-software/priority-style-react';
import React from 'react';
import styles from '../styles.module.scss';
import poweredBy from '../images/poweredBy.png';

export const Footer = ({
    isPayment,
    total,
    submitPayment,
    isPaymentButtonDisabled,
    isBankTransfer
}) => {
    return (
        <>
            {isPayment && (
                <Flex justifyContent="space-between" componentClasses={styles.formRow}>
                    <Text skin="paragraph-1" textColor={'primary-700'}>
                        Total
                    </Text>
                    <Text skin="paragraph-1" textColor={'primary-700'}>
                        {total || '0'}
                    </Text>
                </Flex>
            )}
            {isBankTransfer && (
                <Text skin="breadcrumb" textColor={'primary-700'}>
                    I authorize BlueSnap to electronically debit my account, and, if necessary,
                    electronically credit my account, to correct erroneous debits.
                </Text>
            )}
            {!isBankTransfer && !isPayment && (
                <Text skin="breadcrumb" textColor={'primary-700'}>
                    Save my credit card details for recurring payments or future transactions.
                </Text>
            )}
            <Flex>
                <Button
                    onClick={submitPayment}
                    componentClasses={styles.button}
                    size="medium"
                    disabled={isPaymentButtonDisabled}
                >
                    {isPayment ? 'Pay Now' : 'Save'}
                </Button>
                <img src={poweredBy} alt="" />
            </Flex>
        </>
    );
};
